import { logger } from './logger.js';

function isValidQrProgress(parsed) {
  return Array.isArray(parsed) &&
    parsed.every(step => typeof step === 'number' && step >= 0 && step <= 10);
}

function isValidQuizProgress(parsed) {
  return parsed && typeof parsed === 'object' &&
    typeof parsed.currentIndex === 'number' && parsed.results && typeof parsed.results === 'object';
}

export function safeGetItem(key, defaultValue = null) {
  try {
    const item = localStorage.getItem(key);
    if (item === null) return defaultValue;

    const parsed = JSON.parse(item);

    if (key.includes('qr-progress-') && !isValidQrProgress(parsed)) return defaultValue;
    if (key.includes('quiz-progress-') && !isValidQuizProgress(parsed)) return defaultValue;

    return parsed;
  } catch (error) {
    logger.warn(`Invalid localStorage data for key "${key}":`, error);
    return defaultValue;
  }
}

function evictOldProgressEntries(currentKey) {
  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const existingKey = localStorage.key(i);
    if (existingKey && existingKey !== currentKey &&
        (existingKey.includes('qr-progress-') || existingKey.includes('quiz-progress-'))) {
      keysToRemove.push(existingKey);
    }
  }
  keysToRemove.slice(0, 5).forEach(k => localStorage.removeItem(k));
}

export function safeSetItem(key, value) {
  let serialized;
  if (key.includes('qr-progress-') && Array.isArray(value)) {
    const validated = value.filter(step => typeof step === 'number' && step >= 0 && step <= 10);
    serialized = JSON.stringify(validated);
  } else {
    serialized = JSON.stringify(value);
  }

  try {
    localStorage.setItem(key, serialized);
    return true;
  } catch (error) {
    if (error.name !== 'QuotaExceededError' && error.code !== 22) {
      logger.warn(`Failed to save to localStorage for key "${key}":`, error);
      return false;
    }

    logger.warn('localStorage quota exceeded, attempting cleanup...');
    try {
      evictOldProgressEntries(key);
      localStorage.setItem(key, serialized);
      return true;
    } catch (retryError) {
      logger.error('localStorage cleanup and retry failed:', retryError);
      return false;
    }
  }
}

export function safeRemoveItem(key) {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (error) {
    logger.warn(`Failed to remove localStorage key "${key}":`, error);
    return false;
  }
}
